<template>
  <div />
</template>

<script lang="ts">
import PlausibleAnaliticsEventBus from '~/core/events/plausible'
import CookiesRepository from '~/core/ts/repository/CookiesRepository'

export type PlausibleWindow = Window & {
  plausible: (eventName: string, payload: Record<string, any>) => void,
}

type PlausibleEvent = {
  revenue: {
    amount: number,
    currency: 'EUR',
  } | undefined,
  props: {
    purchase_id: string,
    voucher_id: string,
  }
}

export default defineNuxtComponent({
  setup() {
    function mount() {
      const win = window as any
      if (win.plausible) {
        return
      }

      win.plausible = win.plausible || function() { (win.plausible.q = win.plausible.q || []).push(arguments) }

      const plausibleScript = document.createElement('script')
      plausibleScript.setAttribute('src', 'https://plausible.io/js/script.revenue.js')
      plausibleScript.setAttribute('defer', 'defer')
      plausibleScript.setAttribute('type', 'text/javascript')
      document.body.appendChild(plausibleScript)
    }

    function mountIfAllowed() {
      const win = window as any
      if (win.plausible) {
        return
      }

      if (CookiesRepository.isCookieAllowed('plausible')) {
        mount()
      }
    }

    onMounted(() => {
      mountIfAllowed()

      CookiesRepository.addCookieConsentCallback(() => {
        mountIfAllowed()
      })
    })

    PlausibleAnaliticsEventBus.on((name: string, meta: PlausibleEvent) => {
      const win = window as unknown as PlausibleWindow
      if (!win.plausible) {
        return
      }

      win.plausible(name, meta)

      const blockers = CookiesRepository.getCookiesAsObject('blockers')
      if (blockers.enabled) {
        const { purchase_id, voucher_id } = meta.props
        if (!purchase_id) {
          return
        }

        const adblockEvent = {
          name,
          purchase_id,
          voucher_id,

          cookies_accepted: CookiesRepository.isCookieAllowed('plausible'),
          adblock_enabled: true,
        }

        win.plausible('Event with adblock', adblockEvent)
      }
    })

    return {}
  },
})
</script>
